import React from "react";
import { MagnifyingGlass, X } from "@phosphor-icons/react";

export const SearchBar = ({ value, onChange, placeholder, testId }) => (
  <div className="relative mb-4 max-w-md">
    <MagnifyingGlass size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-zinc-400" />
    <input
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      className="h-10 w-full border border-zinc-900 bg-white pl-9 pr-9 text-sm focus:outline-none focus:ring-2 focus:ring-[var(--ny-gold)]"
      data-testid={testId}
    />
    {value && (
      <button onClick={() => onChange("")} className="absolute right-3 top-1/2 -translate-y-1/2 text-zinc-400 hover:text-zinc-900" aria-label="Effacer" data-testid={`${testId}-clear`}>
        <X size={14} weight="bold" />
      </button>
    )}
  </div>
);
